import { gql } from 'graphql-request'
import { graphClient } from '../../graph-client'
import {
  GET_USERS_TASKS_SPECTATORS,
  GET_USER_TASK_SPECTATOR_FIRST,
} from './gql'

import type { Get, GetList } from './types'

// Mutations — stub gql até serem usadas de fato (hooks já existem).
const CREATE_USER_TASK_SPECTATOR = gql`
  mutation CREATE_USER_TASK_SPECTATOR($userId: Int!, $userTaskSpectatorDefaultId: Int!) {
    createUserTaskSpectator(userId: $userId, userTaskSpectatorDefaultId: $userTaskSpectatorDefaultId) {
      status error data { id }
    }
  }
`
const UPDATE_USER_TASK_SPECTATOR = gql`
  mutation UPDATE_USER_TASK_SPECTATOR($userTaskSpectatorId: Int!) {
    updateUserTaskSpectator(userTaskSpectatorId: $userTaskSpectatorId) {
      status error data { id }
    }
  }
`
const DELETE_FOREVER_USER_TASK_SPECTATOR = gql`
  mutation DELETE_FOREVER_USER_TASK_SPECTATOR($userTaskSpectatorId: Int!) {
    deleteForeverUserTaskSpectator(userTaskSpectatorId: $userTaskSpectatorId) {
      status error
    }
  }
`

class UserTaskSpectatorService {
  async getFirst(params: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_USER_TASK_SPECTATOR_FIRST,
      params,
    )

    return request?.getUserTaskSpectatorFirst
  }

  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_USERS_TASKS_SPECTATORS,
      { ...params, take, skip: take * skip },
    )
    return request?.getUsersTasksSpectators
  }

  async create(params: { userId: number; userTaskSpectatorDefaultId: number }) {
    return graphClient.request(CREATE_USER_TASK_SPECTATOR, params)
  }

  async update(params: { userTaskSpectatorId: number }) {
    return graphClient.request(UPDATE_USER_TASK_SPECTATOR, params)
  }

  async deleteForever(params: { userTaskSpectatorId: number }) {
    return graphClient.request(DELETE_FOREVER_USER_TASK_SPECTATOR, params)
  }
}

export const userTaskSpectatorService = new UserTaskSpectatorService()
